import { Component, OnInit, TemplateRef, Input, ContentChild, EventEmitter, Output, ElementRef, ViewChild } from "@angular/core";
import * as _ from 'lodash';
import { AuthService } from "../../services/auth.service";
import { SortPipe } from "../../pipes/sort.pipe";
import * as uuid from "uuid";

@Component({
   selector: "mapfre-auditlib-table",
   templateUrl: "./table.component.html",
   styleUrls: ["./table.component.scss"]
})
export class TableComponent implements OnInit {
   @ContentChild("header", { static: false }) headerTemplate: TemplateRef<any>;
   @ContentChild("body", { static: false }) bodyTemplate: TemplateRef<any>;
   @ViewChild('inputFile', { static: false }) file: ElementRef;
   @Input() header;
   @Input() columns;
   @Input() actions;
   @Input() buttons;
   @Input() createButton;
   @Input() filterButton;
   @Input() exportButton;
   @Input() importButton;
   @Input() sorted = true;
   @Input() collapsed = false;
   _defaultActions = {
      edit: true,
      delete: true
   };

   _body;
   @Input()
   get body() {
      return this._body;
   }
   set body(value) {
      /** Workaround we find the id property name and we order desc unless we find edit property cause is creation mode */
      if (value && value.length > 0) {
         if (!_.hasIn(value[0], 'edit') && this.sorted) {
            const id = _.find(_.keysIn(value[0]), (prop) => { return _.findIndex(prop, 'id') });
            this._body = _.orderBy(value, id, 'desc');
         }
         else {
            this._body = value;
         }

      } else {
         this._body = [];
      }

   }

   @Input()
   set defaultActions(newObject) {
      this._defaultActions = newObject;
      this._defaultActions = _.merge({ delete: true, edit: true }, this._defaultActions);
   }
   get defaultActions() {
      return this._defaultActions;
   }

   _selectData;
   @Input()
   get selectData() {
      return this._selectData;
   }
   set selectData(value) {
      this._selectData = value;
      setTimeout(() => this.selectDataChange.emit(this._selectData));
   }

   @Input() rowsPerPage = 5;

   @Input() selectTable;
   @Input() typeSelect;

   @Output() selectDataChange = new EventEmitter();
   @Output() selectChange = new EventEmitter();
   @Output() actionClicked = new EventEmitter();
   @Output() buttonClicked = new EventEmitter();
   @Output() updated = new EventEmitter();
   @Output() created = new EventEmitter();
   @Output() deleted = new EventEmitter();
   bodyFiltered;
   bodyPaginated;
   sortConfig;
   loading: boolean = false;
   editMode: boolean = false;
   filterMode: boolean = false;
   nuuma: any;

   constructor(private authService: AuthService, private sortPipe: SortPipe) { }

   ngOnInit() {
      this.nuuma = this.authService.getNuuma();
   }

   create() {
      this.body.unshift({ uuid: uuid.v4(), edit: true, USER_INSERT: this.nuuma });
      this.body = [...this.body];
      this.buttonClicked.emit('create');
   }

   onActionClicked(action, item) {
      const index = _.findIndex(this.body, elem => {
         return _.isEqual(elem, item);
      });
      if (action === "cancelled") {
         _.pullAt(this.body, index);
         this.body = [...this.body];
      } else {
         this.actionClicked.emit({ action, item, index });
      }
   }

   onSelectChange(event) {
      this.selectChange.emit(event);
   }

   importExcel() {
      this.file.nativeElement.value = null;
      this.file.nativeElement.click();
   }

   onButtonClicked(button) {
      this.buttonClicked.emit(button.key);
   }

   onSave(formValue, item) {
      const index = _.findIndex(this.body, elem => {
         return _.isEqual(elem, item);
      });
      this.body[index] = _.mergeWith(item, formValue, (srcValue, newValue) => {
         if (!newValue) {
            srcValue = null;
            return srcValue;
         }
         return undefined;
      });
      this.updated.emit(this.body[index]);
   }

   onCreate(formValue, item) {
      const index = _.findIndex(this.body, (elem: any) => {
         return elem.uuid === item.uuid;
      });
      item.edit = false;
      this.body[index] = _.merge(item, formValue);
      this.created.emit(this.body[index]);
   }

   onDelete(item) {
      const index = _.findIndex(this.body, elem => {
         return _.isEqual(elem, item);
      });
      this.deleted.emit({ item, index });
   }

   onFilteredDataChange(filteredData) {
      this.loading = true;
      this.bodyFiltered = filteredData;
      setTimeout(() => {
         this.loading = false;
      });
   }

   onHeaderClick(col) {
      if (col.sortable) {
         let sortConfig = {
            key: col.field,
            order: this.sortConfig ? -this.sortConfig.order : 1
         };
         this.sortConfig = col.sortable ? sortConfig : null;
         this.sort();
      }
   }

   sort() {
      this.bodyFiltered = this.sortConfig ? this.sortPipe.transform(this.bodyFiltered, this.sortConfig) : this.bodyFiltered;
   }
}
